export const orderedSubset = <Id extends string>(ids: Id[], shown: Id[], order: Id[]): Id[] => {
  const known = (order.length > 0 ? order : ids).filter((id) => ids.includes(id))
  const full = [
    ...known,
    ...shown.filter((id) => !known.includes(id)),
    ...ids.filter((id) => !known.includes(id) && !shown.includes(id))
  ]
  const shownQueue = [...shown]

  return full.map((id) => (shown.includes(id) ? (shownQueue.shift() ?? id) : id))
}
